export abstract class BalancesConstants {
    static PRIORDAY: string = 'P';
    static DELAYED: string = 'D';
    static REALTIME: string = 'R';
    static ACCOUNT: string = 'account';
    static BALANCES: string = 'Balances as of ';
    static ACCOUNT_ALL: string = 'ALL';
    static CASH_ACCOUNT_TYPE: string = 'Cash';
    static MARGIN_ACCOUNT_TYPE: string = 'Margin';
    static SHORT_ACCOUNT_TYPE: string = 'Short';
    static BANKCUSTODY_ACCOUNT: string = 'BNKC';
    static PERSHING_CUSTODIAN_CODE: string = 'PLLC';
    static BNY_CUSTODIAN_CODE: string = 'BNYM';
    static BROKERAGE_ACCOUNT: string = 'BKRG';
    static CONSOLIDATED: string = 'Consolidated';
    static PERSHING_ACCOUNTS_ONLY: string = 'Pershing Accounts Only';
    static PORTAL_BALANCES_SUMMARY_URL: string = 'my-practice/details/balances';
    static zeroBalance = 0;
    static zeroDataSet = {
        value: 0,
        difference: null,
        percentChange: null
    };
    static POSITIVE_SIGN: string = '+';
    static NOT_APPLICABLE: string = 'N/A';
    static SUMMARY_CSS: string = '.hero-BalancesSummary_Data';
    static TIME_ZONE: string = 'America/New_York';
    static DATE_FORMAT: string = 'MM/DD/YYYY';
    static SHORTTIME_FORMAT: string = 'LT';
    static PAGENAME: string = 'balance';
    static BROKERAGE_VIEW: string = 'brokerage';
    static CUSTODIAN_VIEW: string = 'custodian';
    static COMBINED_VIEW: string = 'combined';
    static USD_CURRENCY: string = 'USD';
    static ENTITY_ACCOUNT_CONTEXT: string = 'account';
    static ENTITY_GROUP_CONTEXT: string = 'group';
    static BAD_REQUEST_ERROR: number = 3000;
    static SERVICE_UNAVAL_ERROR: number = 3050;
    static TAXRECLAIM: string = 'Tax Reclaim Receivables as of';
    static HYPHEN = '-';
}
